'use strict';

export default class RecoverRequestController {
  /*@ngInject*/
  constructor($http, $q, $timeout) {
    this.$http = $http;
    this.$q = $q;
    this.$timeout = $timeout;

    this.form = {};
    this.submitted = false;
    this.isSaving = false;
    this.errors;
    this.showThankYou = false;
  }

  submitForm(form) {
    if(form.$valid) {
      let self = this;
      this.submitted = true;
      this.isSaving = true;
      this.$http.post('/api/users/recover/password', this.form)
        .then(function(response) {
          self.showThankYou = true;
        }, function(err) {
          self.isSaving = false;
          // Update validity of form fields that match the mongoose errors
          self.errors = {};
          angular.forEach(err.data.errors, (error, field) => {
            form[field].$setValidity('mongoose', false);
            self.errors[field] = error.message;
          });
        });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/account/recover/recoverRequest.controller.js